import { instance } from '@/services/iss-nattag-api.service'
import { VehicleTypePlace } from '@/types/vehicle-type-place'
import { AxiosResponse } from 'axios'

const URL = 'vehicle-type-place'

export const getVehicleTypePlaces = (): Promise<
  AxiosResponse<VehicleTypePlace[]>
> => instance.get(`${URL}`)
